import React from 'react';
import { Box, Switch, Typography } from '@mui/material';
import InfoTip from '../shared/InfoTip';
import { EXPOSE_ERRORS_COPY as COPY, storesNoUpstreamKey } from './mcpUtils';

/**
 * The "Show the AI my API's error messages" switch (`expose_upstream_errors`),
 * shared by the Settings tab and the create dialog.
 *
 * On a shared-key server the API ignores the flag, so the switch stays visible
 * but disabled with the reason — hiding it would leave a customer who switches
 * back to per-user wondering where it went.
 */
const McpExposeErrorsField = ({ checked, onChange, credentialMode, disabled = false }) => {
  const perUser = storesNoUpstreamKey(credentialMode);
  const off = disabled || !perUser;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
        <Switch
          checked={!!checked}
          onChange={(e) => onChange(e.target.checked)}
          disabled={off}
          inputProps={{ 'aria-label': COPY.label }}
        />
        <Typography variant="body2" sx={{ fontWeight: 600, color: off ? 'text.disabled' : 'inherit' }}>
          {COPY.label}
        </Typography>
        <InfoTip title={COPY.tooltip} />
      </Box>
      <Typography variant="caption" sx={{ color: 'text.secondary', lineHeight: 1.55, pl: 1 }}>
        {perUser ? (
          <>
            {checked ? COPY.helperOn : COPY.helperOff} {COPY.always}
          </>
        ) : (
          COPY.sharedOnly
        )}
      </Typography>
    </Box>
  );
};

export default McpExposeErrorsField;
